module.exports = {
  COOKIE_TROVIT_INSTALLATION_ID: 'trovit_installation_id',
  COOKIE_OLD_TROVIT_INSTALLATION_ID: 'uqTrovit',
  COOKIE_TROVIT_ORIGIN_TRACKING: 'trovit_origin',
  COOKIE_TROVIT_SHOW_DOWNLOAD_APP_BANNER: 'trovit_show_download_app_banner',
  COOKIE_TROVIT_SHOW_PERMISSIONS_BANNER_COUNTER: 'trovit_show_permissions_banner_counter',
  COOKIE_TROVIT_AB_TEST: 'trovit_ab_test',
  COOKIE_TROVIT_IS_PUSH_DISALLOW: 'trovit_is_push_disallow',
  COOKIE_TROVIT_SENDING_ID: 'trovit_sending_id',
  COOKIE_TROVIT_LAST_SEARCH: 'trovit_last_search',
  COOKIE_TROVIT_PERSONALIZED_GOOGLE_ADS: 'trovit_personalized_google_ads',
  COOKIE_TROVIT_SHOW_GDPR_COOKIE_BANNER: 'trovit_show_gdpr',
  COOKIE_TROVIT_NOTIFICATIONS_MANAGER_USER_CREDENTIALS:
    'trovit_notifications_manager_user_credentials',
};



// WEBPACK FOOTER //
// ./app/cookies.js